// Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.
export function isHTMLElement(element: Element | null): element is HTMLElement {
  return !!element && !!(element as HTMLElement).blur;
}
